<template>
  <div id="help-user-manual">
    <div v-if="pdfList.length" class="device-buttons-wp mb-4">
      <vs-button
        style="display: none;"
        v-for="(item, index) in pdfList"
        :key="`popup-${item.label}`"
        color="primary"
        @click="currentPage = 1; currentPdf = item.value"
        type="flat" 
        :icon="index ? 'assignment' : 'description'"
        size="small"
        class="mr-3 device-button"
      >
        {{ item.label }}
      </vs-button>
    </div>

    <vs-row>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" class="mb-8">
        <span>{{currentPage}}/{{pageCount}}</span>
      </vs-col>
    </vs-row>

    <vs-row>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="1">
        <vs-button 
          radius 
          color="primary" 
          type="flat"
          icon="chevron_left"
          @click="previousPdfPage"
          :disabled="currentPage === 1"
        />
      </vs-col>

      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
        <vx-card>
          <pdf
            :page="currentPage"
            @num-pages="pageCount = $event"
            @page-loaded="currentPage = $event"
            :src="currentPdf"
          />
        </vx-card>
      </vs-col>

      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="1">
        <vs-button 
          radius 
          color="primary"
          type="flat"
          icon="chevron_right"
          @click="nextPdfPage"
          :disabled="currentPage === pageCount"
        />
      </vs-col>
    </vs-row>

    <vs-row>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" class="mt-8">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="5">
          <vs-pagination
            v-if="pageCount && currentPage"
            :total="pageCount" 
            v-model="currentPage" 
            prev-icon="arrow_back" 
            next-icon="arrow_forward"
          />
        </vs-col>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
  import pdf from 'vue-pdf'
  import moduleContract from '@/store/contract/moduleContract'

  export default {
    name: 'configs-contract-proposal-pdf',
    data() {
      return {
        currentPdf: '',
        contractInfos: {},
        pdfList: [],
        currentPage: 1,
        pageCount: 1,
      }
    },
    methods: {
      setData() {
        this.contractInfos = this.$store.state.contract.contract

        this.pdfList.push({
          label: 'Contrato de Prestação de Serviços',
          value: this.contractInfos.proposal_pdf_url
        })

        /*this.pdfList.push({
          label: 'Contrato',
          value: this.contractInfos.contract_pdf_url
        })*/

        this.currentPdf = this.contractInfos.proposal_pdf_url
      },
      signContract() {
        this.$store.dispatch("contract/signContract")
        .then(() => { this.closeContractPopup() })
        .catch(err => { console.error(err) })
      },
      previousPdfPage() {
        if (this.currentPage > 1) {
          this.currentPage--
        }
      },
      nextPdfPage() {
        if (this.currentPage < this.pageCount) {
          this.currentPage++
        }
      }
    },
    created() {
      if (!moduleContract.isRegistered) {
        this.$store.registerModule('contract', moduleContract)
        moduleContract.isRegistered = true
      }

      this.$store.dispatch("contract/contractInfos").then(() => {
        this.setData()
      })
    },
    mounted() {
      this.isMounted = true
    },
    components: {
      pdf
    }
  }
</script>

<style scoped>
.device-buttons-wp {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.device-button {
  font-size: 1em !important;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>